module.exports = __webpack_public_path__ + "img/error_500.ada873b.png";